import { useCallback, useState } from "react";

/**
 * Login formları için koşullu captcha durumu.
 *
 * - `captchaRequired`: backend hata gövdesinden (errorCode CAPTCHA_* veya
 *   captchaRequired === true) set edilir; widget yalnızca bu durumda gösterilir.
 * - `captchaPayload`: çözülen ALTCHA payload'ı; tek kullanımlık olduğu için her
 *   denemeden sonra temizlenir ve `captchaKey` artırılarak widget yeniden
 *   mount edilir (yeni challenge).
 */
export const useLoginCaptcha = () => {
  const [captchaRequired, setCaptchaRequired] = useState(false);
  const [captchaPayload, setCaptchaPayload] = useState<string | null>(null);
  const [captchaKey, setCaptchaKey] = useState(0);

  /** Her login denemesinin sonunda çağrılır (başarılı ya da başarısız). */
  const resetAfterAttempt = useCallback((required?: boolean) => {
    if (required !== undefined) setCaptchaRequired(required);
    setCaptchaPayload(null);
    setCaptchaKey((k) => k + 1);
  }, []);

  return {
    captchaRequired,
    captchaPayload,
    captchaKey,
    setCaptchaPayload,
    resetAfterAttempt,
    /** Captcha gerekiyorsa ve henüz çözülmediyse submit kapalı kalır. */
    isCaptchaBlocking: captchaRequired && !captchaPayload,
  };
};
